import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth as authApi } from '../utils/api';

// Reset password self-service, richiesta (Fetta 5b). Risposta sempre generica
// lato server (anti-enumeration): a schermo mostriamo lo stesso messaggio sia
// che l'email esista o no.
export default function PasswordDimenticata() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [inviato, setInviato] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authApi.passwordResetRequest(email.trim().toLowerCase());
      setInviato(true);
    } catch {
      setError('Non siamo riusciti a inviare il link. Riprova tra qualche istante.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Guscio titolo="Password dimenticata">
      {inviato ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--ds-muted)', lineHeight: 1.6, marginBottom: 20 }}>
            Se l'email è registrata, riceverai a breve un link per reimpostare la
            password. Controlla anche la posta indesiderata. Il link scade tra 1 ora.
          </p>
          <button
            onClick={() => navigate('/auth/login')}
            className="gradient-brand"
            style={btnPrimario}
          >
            Torna all'accesso
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <p style={{ fontSize: 12, color: 'var(--ds-muted)', margin: 0 }}>
            Inserisci l'email del tuo account: ti manderemo un link per scegliere
            una nuova password.
          </p>
          <div>
            <label style={labelStyle}>Email</label>
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@azienda.it" required style={inputStyle}
            />
          </div>
          {error && (
            <div style={erroreStyle}>{error}</div>
          )}
          <button type="submit" disabled={loading} className="gradient-brand" style={{ ...btnPrimario, opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Invio in corso…' : 'Invia il link'}
          </button>
          <button
            type="button" onClick={() => navigate('/auth/login')}
            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 11, fontWeight: 500, color: 'var(--ds-muted)' }}
          >
            Torna all'accesso
          </button>
        </form>
      )}
    </Guscio>
  );
}

const labelStyle = { fontSize: 11, fontWeight: 500, color: 'var(--ds-text)', display: 'block', marginBottom: 6 };
const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)',
  background: 'var(--chip)', fontSize: 12, color: 'var(--ds-text)', boxSizing: 'border-box',
};
const btnPrimario = {
  width: '100%', padding: '11px 0', borderRadius: 'var(--radius-base)', border: 'none',
  cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'white', boxShadow: '0 2px 10px rgba(35,38,47,0.06)',
};
const erroreStyle = {
  fontSize: 11, color: 'var(--ds-danger)', background: 'color-mix(in srgb, var(--ds-danger) 8%, transparent)',
  borderRadius: 'var(--radius-base)', padding: '8px 12px',
};

// Guscio grafico condiviso (stessa veste del Login/Registrati).
function Guscio({ titolo, children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--chip)', padding: '32px 0' }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 32 }}>
          <div className="gradient-brand" style={{ width: 52, height: 52, borderRadius: 'var(--radius-card)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, boxShadow: '0 6px 18px rgba(35,38,47,0.08)' }}>
            <span style={{ color: 'white', fontWeight: 500, fontSize: 22, fontStyle: 'italic' }}>m</span>
          </div>
          <div style={{ fontSize: 20, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>mAIstro</div>
        </div>
        <div style={{ background: 'var(--ds-bg)', borderRadius: 'var(--radius-card)', border: '1px solid var(--ds-border)', padding: 28, boxShadow: '0 6px 18px rgba(35,38,47,0.08)' }}>
          <h2 style={{ fontSize: 16, fontWeight: 500, color: 'var(--ink)', marginTop: 0, marginBottom: 16, fontFamily: 'var(--font-display)' }}>{titolo}</h2>
          {children}
        </div>
      </div>
    </div>
  );
}
